

// Copied and simplied from from: https://github.com/matiassingers/emoji-flags/blob/93ae745/data.json
// Also commented out the EU.
//
// And from manipulating the HTML on https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes#Current_ISO_3166_country_codes
// with: console.log(JSON.stringify(Object.fromEntries(Array.from(temp0.children).map(e => [e.children[2]?.innerText, e.children[3]?.innerText]))))
// and storing that in map_2_to_3
// Also added Kosovo with "XK": "XKX"

const matiassingers_countries_data = [
    {
        code2: "AD",
        code3: "",
        emoji: "🇦🇩",
        name: "Andorra",
    },
    {
        code2: "AE",
        code3: "",
        emoji: "🇦🇪",
        name: "United Arab Emirates",
    },
    {
        code2: "AF",
        code3: "",
        emoji: "🇦🇫",
        name: "Afghanistan",
    },
    {
        code2: "AG",
        code3: "",
        emoji: "🇦🇬",
        name: "Antigua and Barbuda",
    },
    {
        code2: "AI",
        code3: "",
        emoji: "🇦🇮",
        name: "Anguilla",
    },
    {
        code2: "AL",
        code3: "",
        emoji: "🇦🇱",
        name: "Albania",
    },
    {
        code2: "AM",
        code3: "",
        emoji: "🇦🇲",
        name: "Armenia",
    },
    {
        code2: "AO",
        code3: "",
        emoji: "🇦🇴",
        name: "Angola",
    },
    {
        code2: "AQ",
        code3: "",
        emoji: "🇦🇶",
        name: "Antarctica",
    },
    {
        code2: "AR",
        code3: "",
        emoji: "🇦🇷",
        name: "Argentina",
    },
    {
        code2: "AS",
        code3: "",
        emoji: "🇦🇸",
        name: "American Samoa",
    },
    {
        code2: "AT",
        code3: "",
        emoji: "🇦🇹",
        name: "Austria",
    },
    {
        code2: "AU",
        code3: "",
        emoji: "🇦🇺",
        name: "Australia",
    },
    {
        code2: "AW",
        code3: "",
        emoji: "🇦🇼",
        name: "Aruba",
    },
    {
        code2: "AX",
        code3: "",
        emoji: "🇦🇽",
        name: "Åland Islands",
    },
    {
        code2: "AZ",
        code3: "",
        emoji: "🇦🇿",
        name: "Azerbaijan",
    },
    {
        code2: "BA",
        code3: "",
        emoji: "🇧🇦",
        name: "Bosnia and Herzegovina",
    },
    {
        code2: "BB",
        code3: "",
        emoji: "🇧🇧",
        name: "Barbados",
    },
    {
        code2: "BD",
        code3: "",
        emoji: "🇧🇩",
        name: "Bangladesh",
    },
    {
        code2: "BE",
        code3: "",
        emoji: "🇧🇪",
        name: "Belgium",
    },
    {
        code2: "BF",
        code3: "",
        emoji: "🇧🇫",
        name: "Burkina Faso",
    },
    {
        code2: "BG",
        code3: "",
        emoji: "🇧🇬",
        name: "Bulgaria",
    },
    {
        code2: "BH",
        code3: "",
        emoji: "🇧🇭",
        name: "Bahrain",
    },
    {
        code2: "BI",
        code3: "",
        emoji: "🇧🇮",
        name: "Burundi",
    },
    {
        code2: "BJ",
        code3: "",
        emoji: "🇧🇯",
        name: "Benin",
    },
    {
        code2: "BL",
        code3: "",
        emoji: "🇧🇱",
        name: "Saint Barthélemy",
    },
    {
        code2: "BM",
        code3: "",
        emoji: "🇧🇲",
        name: "Bermuda",
    },
    {
        code2: "BN",
        code3: "",
        emoji: "🇧🇳",
        name: "Brunei Darussalam",
    },
    {
        code2: "BO",
        code3: "",
        emoji: "🇧🇴",
        name: "Bolivia",
    },
    {
        code2: "BQ",
        code3: "",
        emoji: "🇧🇶",
        name: "Bonaire, Sint Eustatius and Saba",
    },
    {
        code2: "BR",
        code3: "",
        emoji: "🇧🇷",
        name: "Brazil",
    },
    {
        code2: "BS",
        code3: "",
        emoji: "🇧🇸",
        name: "Bahamas",
    },
    {
        code2: "BT",
        code3: "",
        emoji: "🇧🇹",
        name: "Bhutan",
    },
    {
        code2: "BV",
        code3: "",
        emoji: "🇧🇻",
        name: "Bouvet Island",
    },
    {
        code2: "BW",
        code3: "",
        emoji: "🇧🇼",
        name: "Botswana",
    },
    {
        code2: "BY",
        code3: "",
        emoji: "🇧🇾",
        name: "Belarus",
    },
    {
        code2: "BZ",
        code3: "",
        emoji: "🇧🇿",
        name: "Belize",
    },
    {
        code2: "CA",
        code3: "",
        emoji: "🇨🇦",
        name: "Canada",
    },
    {
        code2: "CC",
        code3: "",
        emoji: "🇨🇨",
        name: "Cocos (Keeling) Islands",
    },
    {
        code2: "CD",
        code3: "",
        emoji: "🇨🇩",
        name: "Congo",
    },
    {
        code2: "CF",
        code3: "",
        emoji: "🇨🇫",
        name: "Central African Republic",
    },
    {
        code2: "CG",
        code3: "",
        emoji: "🇨🇬",
        name: "Congo",
    },
    {
        code2: "CH",
        code3: "",
        emoji: "🇨🇭",
        name: "Switzerland",
    },
    {
        code2: "CI",
        code3: "",
        emoji: "🇨🇮",
        name: "Côte D'Ivoire",
    },
    {
        code2: "CK",
        code3: "",
        emoji: "🇨🇰",
        name: "Cook Islands",
    },
    {
        code2: "CL",
        code3: "",
        emoji: "🇨🇱",
        name: "Chile",
    },
    {
        code2: "CM",
        code3: "",
        emoji: "🇨🇲",
        name: "Cameroon",
    },
    {
        code2: "CN",
        code3: "",
        emoji: "🇨🇳",
        name: "China",
    },
    {
        code2: "CO",
        code3: "",
        emoji: "🇨🇴",
        name: "Colombia",
    },
    {
        code2: "CR",
        code3: "",
        emoji: "🇨🇷",
        name: "Costa Rica",
    },
    {
        code2: "CU",
        code3: "",
        emoji: "🇨🇺",
        name: "Cuba",
    },
    {
        code2: "CV",
        code3: "",
        emoji: "🇨🇻",
        name: "Cape Verde",
    },
    {
        code2: "CW",
        code3: "",
        emoji: "🇨🇼",
        name: "Curaçao",
    },
    {
        code2: "CX",
        code3: "",
        emoji: "🇨🇽",
        name: "Christmas Island",
    },
    {
        code2: "CY",
        code3: "",
        emoji: "🇨🇾",
        name: "Cyprus",
    },
    {
        code2: "CZ",
        code3: "",
        emoji: "🇨🇿",
        name: "Czech Republic",
    },
    {
        code2: "DE",
        code3: "",
        emoji: "🇩🇪",
        name: "Germany",
    },
    {
        code2: "DJ",
        code3: "",
        emoji: "🇩🇯",
        name: "Djibouti",
    },
    {
        code2: "DK",
        code3: "",
        emoji: "🇩🇰",
        name: "Denmark",
    },
    {
        code2: "DM",
        code3: "",
        emoji: "🇩🇲",
        name: "Dominica",
    },
    {
        code2: "DO",
        code3: "",
        emoji: "🇩🇴",
        name: "Dominican Republic",
    },
    {
        code2: "DZ",
        code3: "",
        emoji: "🇩🇿",
        name: "Algeria",
    },
    {
        code2: "EC",
        code3: "",
        emoji: "🇪🇨",
        name: "Ecuador",
    },
    {
        code2: "EE",
        code3: "",
        emoji: "🇪🇪",
        name: "Estonia",
    },
    {
        code2: "EG",
        code3: "",
        emoji: "🇪🇬",
        name: "Egypt",
    },
    {
        code2: "EH",
        code3: "",
        emoji: "🇪🇭",
        name: "Western Sahara",
    },
    {
        code2: "ER",
        code3: "",
        emoji: "🇪🇷",
        name: "Eritrea",
    },
    {
        code2: "ES",
        code3: "",
        emoji: "🇪🇸",
        name: "Spain",
    },
    {
        code2: "ET",
        code3: "",
        emoji: "🇪🇹",
        name: "Ethiopia",
    },
    // {
    //     code2: "EU",
    //     code3: "",
    //     emoji: "🇪🇺",
    //     name: "European Union",
    // },
    {
        code2: "FI",
        code3: "",
        emoji: "🇫🇮",
        name: "Finland",
    },
    {
        code2: "FJ",
        code3: "",
        emoji: "🇫🇯",
        name: "Fiji",
    },
    {
        code2: "FK",
        code3: "",
        emoji: "🇫🇰",
        name: "Falkland Islands (Malvinas)",
    },
    {
        code2: "FM",
        code3: "",
        emoji: "🇫🇲",
        name: "Micronesia",
    },
    {
        code2: "FO",
        code3: "",
        emoji: "🇫🇴",
        name: "Faroe Islands",
    },
    {
        code2: "FR",
        code3: "",
        emoji: "🇫🇷",
        name: "France",
    },
    {
        code2: "GA",
        code3: "",
        emoji: "🇬🇦",
        name: "Gabon",
    },
    {
        code2: "GB",
        code3: "",
        emoji: "🇬🇧",
        name: "United Kingdom",
    },
    {
        code2: "GD",
        code3: "",
        emoji: "🇬🇩",
        name: "Grenada",
    },
    {
        code2: "GE",
        code3: "",
        emoji: "🇬🇪",
        name: "Georgia",
    },
    {
        code2: "GF",
        code3: "",
        emoji: "🇬🇫",
        name: "French Guiana",
    },
    {
        code2: "GG",
        code3: "",
        emoji: "🇬🇬",
        name: "Guernsey",
    },
    {
        code2: "GH",
        code3: "",
        emoji: "🇬🇭",
        name: "Ghana",
    },
    {
        code2: "GI",
        code3: "",
        emoji: "🇬🇮",
        name: "Gibraltar",
    },
    {
        code2: "GL",
        code3: "",
        emoji: "🇬🇱",
        name: "Greenland",
    },
    {
        code2: "GM",
        code3: "",
        emoji: "🇬🇲",
        name: "Gambia",
    },
    {
        code2: "GN",
        code3: "",
        emoji: "🇬🇳",
        name: "Guinea",
    },
    {
        code2: "GP",
        code3: "",
        emoji: "🇬🇵",
        name: "Guadeloupe",
    },
    {
        code2: "GQ",
        code3: "",
        emoji: "🇬🇶",
        name: "Equatorial Guinea",
    },
    {
        code2: "GR",
        code3: "",
        emoji: "🇬🇷",
        name: "Greece",
    },
    {
        code2: "GS",
        code3: "",
        emoji: "🇬🇸",
        name: "South Georgia",
    },
    {
        code2: "GT",
        code3: "",
        emoji: "🇬🇹",
        name: "Guatemala",
    },
    {
        code2: "GU",
        code3: "",
        emoji: "🇬🇺",
        name: "Guam",
    },
    {
        code2: "GW",
        code3: "",
        emoji: "🇬🇼",
        name: "Guinea-Bissau",
    },
    {
        code2: "GY",
        code3: "",
        emoji: "🇬🇾",
        name: "Guyana",
    },
    {
        code2: "HK",
        code3: "",
        emoji: "🇭🇰",
        name: "Hong Kong",
    },
    {
        code2: "HM",
        code3: "",
        emoji: "🇭🇲",
        name: "Heard Island and Mcdonald Islands",
    },
    {
        code2: "HN",
        code3: "",
        emoji: "🇭🇳",
        name: "Honduras",
    },
    {
        code2: "HR",
        code3: "",
        emoji: "🇭🇷",
        name: "Croatia",
    },
    {
        code2: "HT",
        code3: "",
        emoji: "🇭🇹",
        name: "Haiti",
    },
    {
        code2: "HU",
        code3: "",
        emoji: "🇭🇺",
        name: "Hungary",
    },
    {
        code2: "ID",
        code3: "",
        emoji: "🇮🇩",
        name: "Indonesia",
    },
    {
        code2: "IE",
        code3: "",
        emoji: "🇮🇪",
        name: "Ireland",
    },
    {
        code2: "IL",
        code3: "",
        emoji: "🇮🇱",
        name: "Israel",
    },
    {
        code2: "IM",
        code3: "",
        emoji: "🇮🇲",
        name: "Isle of Man",
    },
    {
        code2: "IN",
        code3: "",
        emoji: "🇮🇳",
        name: "India",
    },
    {
        code2: "IO",
        code3: "",
        emoji: "🇮🇴",
        name: "British Indian Ocean Territory",
    },
    {
        code2: "IQ",
        code3: "",
        emoji: "🇮🇶",
        name: "Iraq",
    },
    {
        code2: "IR",
        code3: "",
        emoji: "🇮🇷",
        name: "Iran",
    },
    {
        code2: "IS",
        code3: "",
        emoji: "🇮🇸",
        name: "Iceland",
    },
    {
        code2: "IT",
        code3: "",
        emoji: "🇮🇹",
        name: "Italy",
    },
    {
        code2: "JE",
        code3: "",
        emoji: "🇯🇪",
        name: "Jersey",
    },
    {
        code2: "JM",
        code3: "",
        emoji: "🇯🇲",
        name: "Jamaica",
    },
    {
        code2: "JO",
        code3: "",
        emoji: "🇯🇴",
        name: "Jordan",
    },
    {
        code2: "JP",
        code3: "",
        emoji: "🇯🇵",
        name: "Japan",
    },
    {
        code2: "KE",
        code3: "",
        emoji: "🇰🇪",
        name: "Kenya",
    },
    {
        code2: "KG",
        code3: "",
        emoji: "🇰🇬",
        name: "Kyrgyzstan",
    },
    {
        code2: "KH",
        code3: "",
        emoji: "🇰🇭",
        name: "Cambodia",
    },
    {
        code2: "KI",
        code3: "",
        emoji: "🇰🇮",
        name: "Kiribati",
    },
    {
        code2: "KM",
        code3: "",
        emoji: "🇰🇲",
        name: "Comoros",
    },
    {
        code2: "KN",
        code3: "",
        emoji: "🇰🇳",
        name: "Saint Kitts and Nevis",
    },
    {
        code2: "KP",
        code3: "",
        emoji: "🇰🇵",
        name: "North Korea",
    },
    {
        code2: "KR",
        code3: "",
        emoji: "🇰🇷",
        name: "South Korea",
    },
    {
        code2: "KW",
        code3: "",
        emoji: "🇰🇼",
        name: "Kuwait",
    },
    {
        code2: "KY",
        code3: "",
        emoji: "🇰🇾",
        name: "Cayman Islands",
    },
    {
        code2: "KZ",
        code3: "",
        emoji: "🇰🇿",
        name: "Kazakhstan",
    },
    {
        code2: "LA",
        code3: "",
        emoji: "🇱🇦",
        name: "Lao People's Democratic Republic",
    },
    {
        code2: "LB",
        code3: "",
        emoji: "🇱🇧",
        name: "Lebanon",
    },
    {
        code2: "LC",
        code3: "",
        emoji: "🇱🇨",
        name: "Saint Lucia",
    },
    {
        code2: "LI",
        code3: "",
        emoji: "🇱🇮",
        name: "Liechtenstein",
    },
    {
        code2: "LK",
        code3: "",
        emoji: "🇱🇰",
        name: "Sri Lanka",
    },
    {
        code2: "LR",
        code3: "",
        emoji: "🇱🇷",
        name: "Liberia",
    },
    {
        code2: "LS",
        code3: "",
        emoji: "🇱🇸",
        name: "Lesotho",
    },
    {
        code2: "LT",
        code3: "",
        emoji: "🇱🇹",
        name: "Lithuania",
    },
    {
        code2: "LU",
        code3: "",
        emoji: "🇱🇺",
        name: "Luxembourg",
    },
    {
        code2: "LV",
        code3: "",
        emoji: "🇱🇻",
        name: "Latvia",
    },
    {
        code2: "LY",
        code3: "",
        emoji: "🇱🇾",
        name: "Libya",
    },
    {
        code2: "MA",
        code3: "",
        emoji: "🇲🇦",
        name: "Morocco",
    },
    {
        code2: "MC",
        code3: "",
        emoji: "🇲🇨",
        name: "Monaco",
    },
    {
        code2: "MD",
        code3: "",
        emoji: "🇲🇩",
        name: "Moldova",
    },
    {
        code2: "ME",
        code3: "",
        emoji: "🇲🇪",
        name: "Montenegro",
    },
    {
        code2: "MF",
        code3: "",
        emoji: "🇲🇫",
        name: "Saint Martin (French Part)",
    },
    {
        code2: "MG",
        code3: "",
        emoji: "🇲🇬",
        name: "Madagascar",
    },
    {
        code2: "MH",
        code3: "",
        emoji: "🇲🇭",
        name: "Marshall Islands",
    },
    {
        code2: "MK",
        code3: "",
        emoji: "🇲🇰",
        name: "Macedonia",
    },
    {
        code2: "ML",
        code3: "",
        emoji: "🇲🇱",
        name: "Mali",
    },
    {
        code2: "MM",
        code3: "",
        emoji: "🇲🇲",
        name: "Myanmar",
    },
    {
        code2: "MN",
        code3: "",
        emoji: "🇲🇳",
        name: "Mongolia",
    },
    {
        code2: "MO",
        code3: "",
        emoji: "🇲🇴",
        name: "Macao",
    },
    {
        code2: "MP",
        code3: "",
        emoji: "🇲🇵",
        name: "Northern Mariana Islands",
    },
    {
        code2: "MQ",
        code3: "",
        emoji: "🇲🇶",
        name: "Martinique",
    },
    {
        code2: "MR",
        code3: "",
        emoji: "🇲🇷",
        name: "Mauritania",
    },
    {
        code2: "MS",
        code3: "",
        emoji: "🇲🇸",
        name: "Montserrat",
    },
    {
        code2: "MT",
        code3: "",
        emoji: "🇲🇹",
        name: "Malta",
    },
    {
        code2: "MU",
        code3: "",
        emoji: "🇲🇺",
        name: "Mauritius",
    },
    {
        code2: "MV",
        code3: "",
        emoji: "🇲🇻",
        name: "Maldives",
    },
    {
        code2: "MW",
        code3: "",
        emoji: "🇲🇼",
        name: "Malawi",
    },
    {
        code2: "MX",
        code3: "",
        emoji: "🇲🇽",
        name: "Mexico",
    },
    {
        code2: "MY",
        code3: "",
        emoji: "🇲🇾",
        name: "Malaysia",
    },
    {
        code2: "MZ",
        code3: "",
        emoji: "🇲🇿",
        name: "Mozambique",
    },
    {
        code2: "NA",
        code3: "",
        emoji: "🇳🇦",
        name: "Namibia",
    },
    {
        code2: "NC",
        code3: "",
        emoji: "🇳🇨",
        name: "New Caledonia",
    },
    {
        code2: "NE",
        code3: "",
        emoji: "🇳🇪",
        name: "Niger",
    },
    {
        code2: "NF",
        code3: "",
        emoji: "🇳🇫",
        name: "Norfolk Island",
    },
    {
        code2: "NG",
        code3: "",
        emoji: "🇳🇬",
        name: "Nigeria",
    },
    {
        code2: "NI",
        code3: "",
        emoji: "🇳🇮",
        name: "Nicaragua",
    },
    {
        code2: "NL",
        code3: "",
        emoji: "🇳🇱",
        name: "Netherlands",
    },
    {
        code2: "NO",
        code3: "",
        emoji: "🇳🇴",
        name: "Norway",
    },
    {
        code2: "NP",
        code3: "",
        emoji: "🇳🇵",
        name: "Nepal",
    },
    {
        code2: "NR",
        code3: "",
        emoji: "🇳🇷",
        name: "Nauru",
    },
    {
        code2: "NU",
        code3: "",
        emoji: "🇳🇺",
        name: "Niue",
    },
    {
        code2: "NZ",
        code3: "",
        emoji: "🇳🇿",
        name: "New Zealand",
    },
    {
        code2: "OM",
        code3: "",
        emoji: "🇴🇲",
        name: "Oman",
    },
    {
        code2: "PA",
        code3: "",
        emoji: "🇵🇦",
        name: "Panama",
    },
    {
        code2: "PE",
        code3: "",
        emoji: "🇵🇪",
        name: "Peru",
    },
    {
        code2: "PF",
        code3: "",
        emoji: "🇵🇫",
        name: "French Polynesia",
    },
    {
        code2: "PG",
        code3: "",
        emoji: "🇵🇬",
        name: "Papua New Guinea",
    },
    {
        code2: "PH",
        code3: "",
        emoji: "🇵🇭",
        name: "Philippines",
    },
    {
        code2: "PK",
        code3: "",
        emoji: "🇵🇰",
        name: "Pakistan",
    },
    {
        code2: "PL",
        code3: "",
        emoji: "🇵🇱",
        name: "Poland",
    },
    {
        code2: "PM",
        code3: "",
        emoji: "🇵🇲",
        name: "Saint Pierre and Miquelon",
    },
    {
        code2: "PN",
        code3: "",
        emoji: "🇵🇳",
        name: "Pitcairn",
    },
    {
        code2: "PR",
        code3: "",
        emoji: "🇵🇷",
        name: "Puerto Rico",
    },
    {
        code2: "PS",
        code3: "",
        emoji: "🇵🇸",
        name: "Palestinian Territory",
    },
    {
        code2: "PT",
        code3: "",
        emoji: "🇵🇹",
        name: "Portugal",
    },
    {
        code2: "PW",
        code3: "",
        emoji: "🇵🇼",
        name: "Palau",
    },
    {
        code2: "PY",
        code3: "",
        emoji: "🇵🇾",
        name: "Paraguay",
    },
    {
        code2: "QA",
        code3: "",
        emoji: "🇶🇦",
        name: "Qatar",
    },
    {
        code2: "RE",
        code3: "",
        emoji: "🇷🇪",
        name: "Réunion",
    },
    {
        code2: "RO",
        code3: "",
        emoji: "🇷🇴",
        name: "Romania",
    },
    {
        code2: "RS",
        code3: "",
        emoji: "🇷🇸",
        name: "Serbia",
    },
    {
        code2: "RU",
        code3: "",
        emoji: "🇷🇺",
        name: "Russia",
    },
    {
        code2: "RW",
        code3: "",
        emoji: "🇷🇼",
        name: "Rwanda",
    },
    {
        code2: "SA",
        code3: "",
        emoji: "🇸🇦",
        name: "Saudi Arabia",
    },
    {
        code2: "SB",
        code3: "",
        emoji: "🇸🇧",
        name: "Solomon Islands",
    },
    {
        code2: "SC",
        code3: "",
        emoji: "🇸🇨",
        name: "Seychelles",
    },
    {
        code2: "SD",
        code3: "",
        emoji: "🇸🇩",
        name: "Sudan",
    },
    {
        code2: "SE",
        code3: "",
        emoji: "🇸🇪",
        name: "Sweden",
    },
    {
        code2: "SG",
        code3: "",
        emoji: "🇸🇬",
        name: "Singapore",
    },
    {
        code2: "SH",
        code3: "",
        emoji: "🇸🇭",
        name: "Saint Helena, Ascension and Tristan Da Cunha",
    },
    {
        code2: "SI",
        code3: "",
        emoji: "🇸🇮",
        name: "Slovenia",
    },
    {
        code2: "SJ",
        code3: "",
        emoji: "🇸🇯",
        name: "Svalbard and Jan Mayen",
    },
    {
        code2: "SK",
        code3: "",
        emoji: "🇸🇰",
        name: "Slovakia",
    },
    {
        code2: "SL",
        code3: "",
        emoji: "🇸🇱",
        name: "Sierra Leone",
    },
    {
        code2: "SM",
        code3: "",
        emoji: "🇸🇲",
        name: "San Marino",
    },
    {
        code2: "SN",
        code3: "",
        emoji: "🇸🇳",
        name: "Senegal",
    },
    {
        code2: "SO",
        code3: "",
        emoji: "🇸🇴",
        name: "Somalia",
    },
    {
        code2: "SR",
        code3: "",
        emoji: "🇸🇷",
        name: "Suriname",
    },
    {
        code2: "SS",
        code3: "",
        emoji: "🇸🇸",
        name: "South Sudan",
    },
    {
        code2: "ST",
        code3: "",
        emoji: "🇸🇹",
        name: "Sao Tome and Principe",
    },
    {
        code2: "SV",
        code3: "",
        emoji: "🇸🇻",
        name: "El Salvador",
    },
    {
        code2: "SX",
        code3: "",
        emoji: "🇸🇽",
        name: "Sint Maarten (Dutch Part)",
    },
    {
        code2: "SY",
        code3: "",
        emoji: "🇸🇾",
        name: "Syrian Arab Republic",
    },
    {
        code2: "SZ",
        code3: "",
        emoji: "🇸🇿",
        name: "Swaziland",
    },
    {
        code2: "TC",
        code3: "",
        emoji: "🇹🇨",
        name: "Turks and Caicos Islands",
    },
    {
        code2: "TD",
        code3: "",
        emoji: "🇹🇩",
        name: "Chad",
    },
    {
        code2: "TF",
        code3: "",
        emoji: "🇹🇫",
        name: "French Southern Territories",
    },
    {
        code2: "TG",
        code3: "",
        emoji: "🇹🇬",
        name: "Togo",
    },
    {
        code2: "TH",
        code3: "",
        emoji: "🇹🇭",
        name: "Thailand",
    },
    {
        code2: "TJ",
        code3: "",
        emoji: "🇹🇯",
        name: "Tajikistan",
    },
    {
        code2: "TK",
        code3: "",
        emoji: "🇹🇰",
        name: "Tokelau",
    },
    {
        code2: "TL",
        code3: "",
        emoji: "🇹🇱",
        name: "Timor-Leste",
    },
    {
        code2: "TM",
        code3: "",
        emoji: "🇹🇲",
        name: "Turkmenistan",
    },
    {
        code2: "TN",
        code3: "",
        emoji: "🇹🇳",
        name: "Tunisia",
    },
    {
        code2: "TO",
        code3: "",
        emoji: "🇹🇴",
        name: "Tonga",
    },
    {
        code2: "TR",
        code3: "",
        emoji: "🇹🇷",
        name: "Turkey",
    },
    {
        code2: "TT",
        code3: "",
        emoji: "🇹🇹",
        name: "Trinidad and Tobago",
    },
    {
        code2: "TV",
        code3: "",
        emoji: "🇹🇻",
        name: "Tuvalu",
    },
    {
        code2: "TW",
        code3: "",
        emoji: "🇹🇼",
        name: "Taiwan",
    },
    {
        code2: "TZ",
        code3: "",
        emoji: "🇹🇿",
        name: "Tanzania",
    },
    {
        code2: "UA",
        code3: "",
        emoji: "🇺🇦",
        name: "Ukraine",
    },
    {
        code2: "UG",
        code3: "",
        emoji: "🇺🇬",
        name: "Uganda",
    },
    {
        code2: "UM",
        code3: "",
        emoji: "🇺🇲",
        name: "United States Minor Outlying Islands",
    },
    {
        code2: "US",
        code3: "",
        emoji: "🇺🇸",
        name: "United States",
    },
    {
        code2: "UY",
        code3: "",
        emoji: "🇺🇾",
        name: "Uruguay",
    },
    {
        code2: "UZ",
        code3: "",
        emoji: "🇺🇿",
        name: "Uzbekistan",
    },
    {
        code2: "VA",
        code3: "",
        emoji: "🇻🇦",
        name: "Vatican City",
    },
    {
        code2: "VC",
        code3: "",
        emoji: "🇻🇨",
        name: "Saint Vincent and The Grenadines",
    },
    {
        code2: "VE",
        code3: "",
        emoji: "🇻🇪",
        name: "Venezuela",
    },
    {
        code2: "VG",
        code3: "",
        emoji: "🇻🇬",
        name: "Virgin Islands, British",
    },
    {
        code2: "VI",
        code3: "",
        emoji: "🇻🇮",
        name: "Virgin Islands, U.S.",
    },
    {
        code2: "VN",
        code3: "",
        emoji: "🇻🇳",
        name: "Viet Nam",
    },
    {
        code2: "VU",
        code3: "",
        emoji: "🇻🇺",
        name: "Vanuatu",
    },
    {
        code2: "WF",
        code3: "",
        emoji: "🇼🇫",
        name: "Wallis and Futuna",
    },
    {
        code2: "WS",
        code3: "",
        emoji: "🇼🇸",
        name: "Samoa",
    },
    {
        code2: "XK",
        code3: "",
        emoji: "🇽🇰",
        name: "Kosovo",
    },
    {
        code2: "YE",
        code3: "",
        emoji: "🇾🇪",
        name: "Yemen",
    },
    {
        code2: "YT",
        code3: "",
        emoji: "🇾🇹",
        name: "Mayotte",
    },
    {
        code2: "ZA",
        code3: "",
        emoji: "🇿🇦",
        name: "South Africa",
    },
    {
        code2: "ZM",
        code3: "",
        emoji: "🇿🇲",
        name: "Zambia",
    },
    {
        code2: "ZW",
        code3: "",
        emoji: "🇿🇼",
        name: "Zimbabwe",
    }
] as const

const map_2_to_3 = {
    "AF": "AFG",
    "AX": "ALA",
    "AL": "ALB",
    "DZ": "DZA",
    "AS": "ASM",
    "AD": "AND",
    "AO": "AGO",
    "AI": "AIA",
    "AQ": "ATA",
    "AG": "ATG",
    "AR": "ARG",
    "AM": "ARM",
    "AW": "ABW",
    "AU": "AUS",
    "AT": "AUT",
    "AZ": "AZE",
    "BS": "BHS",
    "BH": "BHR",
    "BD": "BGD",
    "BB": "BRB",
    "BY": "BLR",
    "BE": "BEL",
    "BZ": "BLZ",
    "BJ": "BEN",
    "BM": "BMU",
    "BT": "BTN",
    "BO": "BOL",
    "BQ": "BES",
    "BA": "BIH",
    "BW": "BWA",
    "BV": "BVT",
    "BR": "BRA",
    "IO": "IOT",
    "BN": "BRN",
    "BG": "BGR",
    "BF": "BFA",
    "BI": "BDI",
    "CV": "CPV",
    "KH": "KHM",
    "CM": "CMR",
    "CA": "CAN",
    "KY": "CYM",
    "CF": "CAF",
    "TD": "TCD",
    "CL": "CHL",
    "CN": "CHN",
    "CX": "CXR",
    "CC": "CCK",
    "CO": "COL",
    "KM": "COM",
    "CD": "COD",
    "CG": "COG",
    "CK": "COK",
    "CR": "CRI",
    "CI": "CIV",
    "HR": "HRV",
    "CU": "CUB",
    "CW": "CUW",
    "CY": "CYP",
    "CZ": "CZE",
    "DK": "DNK",
    "DJ": "DJI",
    "DM": "DMA",
    "DO": "DOM",
    "EC": "ECU",
    "EG": "EGY",
    "SV": "SLV",
    "GQ": "GNQ",
    "ER": "ERI",
    "EE": "EST",
    "SZ": "SWZ",
    "ET": "ETH",
    "FK": "FLK",
    "FO": "FRO",
    "FJ": "FJI",
    "FI": "FIN",
    "FR": "FRA",
    "GF": "GUF",
    "PF": "PYF",
    "TF": "ATF",
    "GA": "GAB",
    "GM": "GMB",
    "GE": "GEO",
    "DE": "DEU",
    "GH": "GHA",
    "GI": "GIB",
    "GR": "GRC",
    "GL": "GRL",
    "GD": "GRD",
    "GP": "GLP",
    "GU": "GUM",
    "GT": "GTM",
    "GG": "GGY",
    "GN": "GIN",
    "GW": "GNB",
    "GY": "GUY",
    "HT": "HTI",
    "HM": "HMD",
    "VA": "VAT",
    "HN": "HND",
    "HK": "HKG",
    "HU": "HUN",
    "IS": "ISL",
    "IN": "IND",
    "ID": "IDN",
    "IR": "IRN",
    "IQ": "IRQ",
    "IE": "IRL",
    "IM": "IMN",
    "IL": "ISR",
    "IT": "ITA",
    "JM": "JAM",
    "JP": "JPN",
    "JE": "JEY",
    "JO": "JOR",
    "KZ": "KAZ",
    "KE": "KEN",
    "KI": "KIR",
    "KP": "PRK",
    "KR": "KOR",
    "KW": "KWT",
    "KG": "KGZ",
    "LA": "LAO",
    "LV": "LVA",
    "LB": "LBN",
    "LS": "LSO",
    "LR": "LBR",
    "LY": "LBY",
    "LI": "LIE",
    "LT": "LTU",
    "LU": "LUX",
    "MO": "MAC",
    "MG": "MDG",
    "MW": "MWI",
    "MY": "MYS",
    "MV": "MDV",
    "ML": "MLI",
    "MT": "MLT",
    "MH": "MHL",
    "MQ": "MTQ",
    "MR": "MRT",
    "MU": "MUS",
    "YT": "MYT",
    "MX": "MEX",
    "FM": "FSM",
    "MD": "MDA",
    "MC": "MCO",
    "MN": "MNG",
    "ME": "MNE",
    "MS": "MSR",
    "MA": "MAR",
    "MZ": "MOZ",
    "MM": "MMR",
    "NA": "NAM",
    "NR": "NRU",
    "NP": "NPL",
    "NL": "NLD",
    "NC": "NCL",
    "NZ": "NZL",
    "NI": "NIC",
    "NE": "NER",
    "NG": "NGA",
    "NU": "NIU",
    "NF": "NFK",
    "MK": "MKD",
    "MP": "MNP",
    "NO": "NOR",
    "OM": "OMN",
    "PK": "PAK",
    "PW": "PLW",
    "PS": "PSE",
    "PA": "PAN",
    "PG": "PNG",
    "PY": "PRY",
    "PE": "PER",
    "PH": "PHL",
    "PN": "PCN",
    "PL": "POL",
    "PT": "PRT",
    "PR": "PRI",
    "QA": "QAT",
    "RE": "REU",
    "RO": "ROU",
    "RU": "RUS",
    "RW": "RWA",
    "BL": "BLM",
    "SH": "SHN",
    "KN": "KNA",
    "LC": "LCA",
    "MF": "MAF",
    "PM": "SPM",
    "VC": "VCT",
    "WS": "WSM",
    "SM": "SMR",
    "ST": "STP",
    "SA": "SAU",
    "SN": "SEN",
    "RS": "SRB",
    "SC": "SYC",
    "SL": "SLE",
    "SG": "SGP",
    "SX": "SXM",
    "SK": "SVK",
    "SI": "SVN",
    "SB": "SLB",
    "SO": "SOM",
    "ZA": "ZAF",
    "GS": "SGS",
    "SS": "SSD",
    "ES": "ESP",
    "LK": "LKA",
    "SD": "SDN",
    "SR": "SUR",
    "SJ": "SJM",
    "SE": "SWE",
    "CH": "CHE",
    "SY": "SYR",
    "TW": "TWN",
    "TJ": "TJK",
    "TZ": "TZA",
    "TH": "THA",
    "TL": "TLS",
    "TG": "TGO",
    "TK": "TKL",
    "TO": "TON",
    "TT": "TTO",
    "TN": "TUN",
    "TR": "TUR",
    "TM": "TKM",
    "TC": "TCA",
    "TV": "TUV",
    "UG": "UGA",
    "UA": "UKR",
    "AE": "ARE",
    "GB": "GBR",
    "UM": "UMI",
    "US": "USA",
    "UY": "URY",
    "UZ": "UZB",
    "VU": "VUT",
    "VE": "VEN",
    "VN": "VNM",
    "VG": "VGB",
    "VI": "VIR",
    "WF": "WLF",
    "EH": "ESH",
    "YE": "YEM",
    "ZM": "ZMB",
    "ZW": "ZWE",
    // Added manually
    "XK": "XKX",
} as const

export const countries_data = matiassingers_countries_data.map((country) => {
    const code3 = map_2_to_3[country.code2]
    return {
        ...country,
        code3,
    }
})

export type CountryISO2Code = typeof countries_data[number]["code2"]
export type CountryISO3Code = typeof countries_data[number]["code3"]
